



/* eslint-disable @typescript-eslint/explicit-function-return-type */
import rt__ from 'bits/relative_time'
import { hyphenatedCurrentLocale } from 'bits/current_locale'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class RelativeTime extends Vue {
  @Prop(String) datetime!: string
  @Prop({ default: 'short' }) dateformat!: 'short' | 'long'
  @Prop({ default: false }) autoupdate!: boolean

  get relativeTime(): string {
    const t = this.datetime
    const f = this.dateformat
    return rt__(t, f)
  }
  get actualTime(): string {
    const date = new Date(this.datetime)
    return date.toLocaleString(hyphenatedCurrentLocale)
  }
}
